// extracted by mini-css-extract-plugin
module.exports = {"addStaffBtn":"staff_addStaffBtn__1-qto","addStaffCont":"staff_addStaffCont__3YDhN","exit":"staff_exit__Qmjz_","checkaval":"staff_checkaval__1kvIM"};